<template>
  <div class="media-uploader">
    <div class="uploader-content position-relative bg-dashboard-dark-2">
      <div class="media-header bg-dashboard-dark-1">
        <div>
          <h1
            class="d-flex justify-content-start align-items-center text-white"
          >
            <span>Select road</span>
          </h1>
        </div>
        <button class="btn-close bg-dashboard-dark-1 text-light" @click="close">
          &times;
        </button>
      </div>
      <div class="media-container overflow-hidden bg-dashboard-dark-1">
        <div class="form-group mb-0 p-3">
          <div class="input-group rounded">
            <input
              type="text"
              class="
                form-control form-control-default
                bg-input-dark
                border-outline-dark-all
                text-white
              "
              placeholder="Search road"
              v-model="searchModel"
            />
            <div class="input-group-append">
              <button
                class="btn dropdown-toggle no-focus text-white btn-secondary"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                {{ districtModel ? districtModel.name : "All Districts" }}
              </button>
              <div
                class="dropdown-menu dropdown-menu-right p-0"
                style="max-height: 47vh; overflow-y: auto"
              >
                <div
                  class="
                    dropdown-item-text
                    small
                    font-italic
                    text-secondary
                    bg-dashboard-dark-2
                    px-3
                    py-2
                    fs-8
                  "
                >
                  Select a district
                </div>
                <!-- <div role="separator" class="dropdown-divider border-dark"></div> -->
                <div
                  class="
                    dropdown-item
                    clickable
                    text-light
                    px-3
                    py-2
                    fs-8
                    btn-hightlight
                    border-outline-dark-bottom
                  "
                  @click="districtModel = null"
                >
                  All Districts
                  <font-awesome-icon
                    :icon="['fas', 'check']"
                    class="text-primary float-right"
                    v-if="!districtModel"
                  />
                </div>
                <div
                  class="
                    dropdown-item
                    clickable
                    text-light
                    px-3
                    py-2
                    fs-8
                    border-outline-dark-bottom
                  "
                  v-for="district in districtFilters"
                  :key="district._id"
                  @click="districtModel = district"
                >
                  {{ district.name }}
                  <font-awesome-icon
                    :icon="['fas', 'check']"
                    class="text-primary float-right"
                    v-if="districtModel && districtModel._id == district._id"
                  />
                </div>
              </div>
            </div>
          </div>
          <p class="small text-muted mb-0 mt-3 px-2">
            Nearest road found:
            <span class="text-primary" v-html="suggestedRoad"></span>
          </p>
        </div>
        <ul
          id="roadList"
          class="list-group list-group-flush"
          style="height: calc(100% - 99px); overflow-y: auto"
        >
          <template v-for="district in computedDistricts">
            <li
              class="
                list-group-item
                p-0
                mb-3
                bg-dashboard-dark-1
                border-outline-dark-all
              "
              :key="district._id"
            >
              <p
                class="
                  mb-0
                  p-3
                  small
                  font-weight-medium
                  sticky-top
                  text-white
                  bg-dark-ds
                  shadow-sm
                  border-outline-dark-bottom
                "
                style="z-index: 1"
              >
                {{ district.name }}
              </p>
              <ul class="list-group px-3 list-group-flush">
                <li
                  class="
                    list-group-item
                    clickable
                    text-light
                    bg-dashboard-dark-1
                    fs-8
                  "
                  v-for="road in district.roads"
                  :key="road._id"
                  @click="selectedRoad = road"
                >
                  {{ road.name }}
                  <font-awesome-icon
                    :icon="['fas', 'check']"
                    class="text-primary float-right"
                    v-if="selectedRoad && selectedRoad._id == road._id"
                  />
                </li>
                <li
                  class="
                    list-group-item
                    font-italic
                    text-muted text-center
                    small
                    bg-dashboard-dark-1
                  "
                  v-if="district.roads.length < 1"
                >
                  No road found
                </li>
              </ul>
            </li>
          </template>
          <li
            class="list-group-item font-italic text-muted text-center small"
            v-if="!districts || computedDistricts.length < 1"
          >
            No road found
          </li>
        </ul>
      </div>
      <div
        class="media-footer bg-dashboard-dark-1 border-outline-dark-top"
        style="margin-top: 1px"
      >
        <button class="btn btn-outline-secondary btn-sm" @click="close">
          Cancel
        </button>
        <button
          class="btn btn-info btn-sm"
          @click="roadSelected"
          :disabled="!selectedRoad"
        >
          Select road
        </button>
      </div>
      <spinner class="position-absolute w-100 h-100" v-if="isProcessing" />
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import Fuse from "fuse.js";
import API from "@/api";
import Spinner from "@/components/Spinner";

export default {
  name: "media-uploader",
  props: ["districts", "videoDistrict", "lat", "lng", "currentRoad"],
  components: {
    Spinner,
  },
  data() {
    return {
      selectedRoad: null,
      searchModel: null,
      districtModel: null,
      suggestedRoad: null,
      roadPreSelected: false,
      isProcessing: false,
    };
  },
  watch: {
    videoDistrict: {
      handler() {
        if (this.videoDistrict) {
          this.districtModel = {
            _id: this.videoDistrict._id,
            name: this.videoDistrict.name,
          };
        }
      },
      deep: true,
      immediate: true,
    },
    // suggestedRoad: {
    //   handler() {
    //     if (this.suggestedRoad) {
    //       let _suggestedRoad = this.suggestedRoad;

    //       const _srArray = _suggestedRoad.split(" ");

    //       if (["jalan", "jln", "j"].includes(_srArray[0].toLowerCase())) {
    //         _srArray.shift();
    //       }

    //       _suggestedRoad = _srArray.join(" ");

    //       this.searchModel = _suggestedRoad;

    //       this.$nextTick(() => {
    //         this.selectedRoad = this.computedDistricts[0].roads[0];
    //       });
    //     }
    //   },
    //   deep: true,
    //   immediate: true,
    // },
  },
  computed: {
    districtFilters() {
      if (this.districts) {
        return this.districts.map((district) => {
          return { _id: district._id, name: district.name };
        });
      } else {
        return [];
      }
    },
    computedDistricts() {
      let _districts = JSON.parse(JSON.stringify(this.districts));

      if (this.districtModel) {
        _districts = _districts.filter(
          (district) => district._id == this.districtModel._id
        );
      }

      let _roads = _districts.map((district) => district.roads).flat();

      if (this.searchModel) {
        const options = {
          includeScore: true,
          keys: ["name"],
        };

        const fuse = new Fuse(_roads, options);

        const result = fuse.search(this.searchModel);

        let mappedResult = [...result];

        _districts = _districts.map((_dis) => {
          _dis.roads = [];

          return _dis;
        });

        mappedResult.forEach((road) => {
          let roadId =
            road.item.daerah && road.item.daerah._id
              ? road.item.daerah._id
              : road.item.daerah;

          let dis = _districts.find((_dis) => _dis._id == roadId);

          if (dis) {
            if (!dis.score || dis.score > road.score) {
              dis.score = road.score;
            }

            dis.roads.push(road.item);
          }
        });

        _districts.sort((a, b) => {
          return a.score - b.score;
        });
      }

      $("#roadList").scrollTop(0);

      return _districts;
    },
  },
  methods: {
    roadSelected() {
      this.$emit("close", this.selectedRoad);
    },
    close() {
      this.$emit("close");
    },
    async getSuggestedRoad() {
      if (this.lat && this.lng) {
        this.isProcessing = true;

        API.get(`roads/nearest?lat=${this.lat}&lng=${this.lng}`)
          .then((retVal) => {
            if (retVal.data) {
              this.suggestedRoad = retVal.data.name;

              this.searchModel = retVal.data.name;

              this.$nextTick(() => {
                this.selectedRoad = this.computedDistricts[0].roads[0];
              });
            } else {
              this.suggestedRoad = null;

              this.searchModel = null;
            }

            this.isProcessing = false;
          })
          .catch(() => {
            this.suggestedRoad =
              "<span class='font-italic'>No suggestion available</span>";

            this.searchModel = null;

            this.isProcessing = false;
          });
      } else {
        this.suggestedRoad =
          "<span class='font-italic text-muted'>No coordinate</span>";

        this.searchModel = null;
      }
    },
  },
  mounted() {
    if (this.currentRoad) {
      this.searchModel = this.currentRoad.name;

      this.selectedRoad = this.currentRoad;
    } else {
      this.getSuggestedRoad();
    }
  },
};
</script>